import {
  selBaseInfoById,
  selBaseInfoTraceByParamNoLogin,
  selBaseInfoYears,
  selManageManufacturerBaseInfo,
  selBaseInfoTraceByRecordEntryTypeNoLogin,
  selHdfDtlDistribution,
  selBaseInfoSingle,
  getLngAndlatToArea,
  selBusinessListByParam,
  selAreaListByName,
} from '@/api/map';

export default {
  namespaced: true,
  actions: {
    // 查询土地信息种植年限
    async selBaseInfoYears(context, params) {
      const { data } = await selBaseInfoYears(params);
      return data;
    },
    // 查询土地面积
    async selBaseInfoById(context, params) {
      const { data } = await selBaseInfoById(params);
      return data;
    },
    // 查询农事记录
    async selBaseInfoTraceByParamNoLogin(context, params) {
      const { data } = await selBaseInfoTraceByParamNoLogin(params);
      return data;
    },
    //查询种植历史
    async selBaseInfoTraceByRecordEntryTypeNoLogin(context, params) {
      const { data } = await selBaseInfoTraceByRecordEntryTypeNoLogin(params);
      return data;
    },
    // 查询土地信息种植年限
    async selManageManufacturerBaseInfo(context, params) {
      const { data } = await selManageManufacturerBaseInfo(params);
      return data;
    },
    // 墒情
    async selHdfDtlDistribution(context, params) {
      const { data } = await selHdfDtlDistribution(params);
      return data;
    },
    async selBaseInfoSingle(context, params) {
      const { data } = await selBaseInfoSingle(params);
      return data;
    },
    async getLngAndlatToArea(context, params) {
      const { data } = await getLngAndlatToArea(params);
      return data;
    },
    async selBusinessListByParam(context, params) {
      const { data } = await selBusinessListByParam(params);
      return data;
    },
    async selAreaListByName(context, params) {
      const { data } = await selAreaListByName(params);
      return data;
    },
  },
};

